import moment from 'moment';
import {initTournamentSeasonSelects} from "../components/tournaments-seasons-selects";

export function initCalendarPageLanding() {
    // Андрей сортируй по возрастанию даты))
    const mockData = [
        {
            link: 'https://www.google.com/',
            club1: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            club2: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2021-09-08',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
                roundNumber: 13,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
           club1: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            club2: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2021-09-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
           club1: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            club2: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2021-10-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
           club1: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            club2: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2021-10-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
           club1: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            club2: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2021-10-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
           club1: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            club2: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2021-11-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
           club1: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            club2: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2021-11-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
           club1: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            club2: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2021-12-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
           club1: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            club2: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2021-12-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
           club1: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            club2: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2022-01-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
           club1: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            club2: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            goal1: 0,
            goal2: 0,
            date: '2022-01-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
           club1: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            club2: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            goal1: 0,
            goal2: 0,
            date: '2022-01-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
           club1: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            club2: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            goal1: 0,
            goal2: 0,
            date: '2022-02-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
            club1: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            club2: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2022-02-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
            club1: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            club2: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2022-03-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
            club1: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            club2: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2022-03-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
            club1: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            club2: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2022-04-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
            club1: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            club2: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2022-04-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
            club1: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            club2: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2022-04-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
            club1: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            club2: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2022-05-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
            club1: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            club2: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2022-05-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
            club1: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            club2: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2022-05-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            "link": "\/matches\/matches_222.html",
            "club1": {
                "id": "32",
                "name": "\u0417\u043d\u0430\u043c\u044f",
                "logo": "https:\/\/ksstatistics.internetlab.ru\/upload\/club32.png"
            },
            "club2": {
                "id": "26",
                "name": "\u041a. \u0421\u043e\u0432\u0435\u0442\u043e\u0432",
                "logo": "https:\/\/ksstatistics.internetlab.ru\/upload\/club26.svg"
            },
            "goal1": "0",
            "goal2": "10",
            "date": "2022-05-22 17:00:00",
            "stadium": "\u041d\u043e\u0433\u0438\u043d\u0441\u043a, \u0417\u043d\u0430\u043c\u044f",
            "tournament": {
                "id": "3",
                "logo": "https:\/\/ksstatistics.internetlab.ru\/upload\/t3.png",
                "name": "\u0411\u0435\u0442\u0441\u0438\u0442\u0438 \u041a\u0443\u0431\u043e\u043a \u0420\u043e\u0441\u0441\u0438\u0438",
                "roundNumber": "\u0413\u0440\u0443\u043f\u043f\u0430 9. 2 \u0442\u0443\u0440"
            },
            "status": "2"
        },
        {
            "link": "\/matches\/matches_223.html",
            "club1": {
                "id": "33",
                "name": "\u0415\u043d\u0438\u0441\u0435\u0439",
                "logo": "https:\/\/ksstatistics.internetlab.ru\/upload\/club33.png"
            },
            "club2": {
                "id": "26",
                "name": "\u041a. \u0421\u043e\u0432\u0435\u0442\u043e\u0432",
                "logo": "https:\/\/ksstatistics.internetlab.ru\/upload\/club26.svg"
            },
            "goal1": "1",
            "goal2": "0",
            "date": "2022-5-27 16:00:00",
            "stadium": "\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u0441\u043a, \u0426\u0435\u043d\u0442\u0440\u0430\u043b\u044c\u043d\u044b\u0439",
            "tournament": {
                "id": "3",
                "logo": "https:\/\/ksstatistics.internetlab.ru\/upload\/t3.png",
                "name": "\u0411\u0435\u0442\u0441\u0438\u0442\u0438 \u041a\u0443\u0431\u043e\u043a \u0420\u043e\u0441\u0441\u0438\u0438",
                "roundNumber": "\u0413\u0440\u0443\u043f\u043f\u0430 9. 3 \u0442\u0443\u0440"
            },
            "status": "2"
        },
        {
            link: 'https://www.google.com/',
            club1: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            club2: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2022-06-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
            club1: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            club2: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2022-06-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
            club1: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            club2: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2022-06-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
            club1: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            club2: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2022-06-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
            club1: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            club2: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            goal1: 1,
            goal2: 2,
            date: '2022-07-08T15:00:00',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
            club1: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            club2: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            goal1: '',
            goal2: '',
            date: '',
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
        {
            link: 'https://www.google.com/',
            club1: {
                id: 26,
                name: 'Крылья Советов',
                logo: './img/icons/clubs/ks.svg',
            },
            club2: {
                id: 11,
                name: 'Локомотив',
                logo: './img/icons/clubs/lokomotiv.svg',
            },
            goal1: '', // пока написано под пустую строку, если будет null или другая строка, дай знать пжл
            goal2: '', // пока написано под пустую строку, если будет null или другая строка, дай знать пжл
            date: '', // пока написано под пустую строку, если будет null или другая строка, дай знать пжл
            stadium: 'Самара, «Солидарность Самара Арена»',
            tournament: {
                logo: './img/icons/leagues/rpl-league.svg',
                name: 'Тинькофф РПЛ, 15 тур',
                id: 0,
            },
            status: 0, //0(не начался) 1 (идет), 2 (завершен)
        },
    ]
    const calendarList = $('#calendar_list');
    const calendarPreloader = $('#table_preloader');
    const selectsContainer = $('#calendar_selects_container');
    const header =  $('.header');
    const pageHead = $('.fixed-page-head');
    const filtersBlock = $('#filter_matches');
    if (!filtersBlock.length) return;

    const settings = filtersBlock.attr('data-settings');
    if (!settings.length) return;
    const parsedSettings = JSON.parse(settings);

    header.addClass('fixed');
    showFiltersHandler();
    initTournamentSeasonSelects(parsedSettings, getMatches);
    getMatches();

    function showFiltersHandler() {
        $('.show-filters').click(function(e) {
            e.preventDefault();
            $(this).toggleClass('open');
        });
    }

    // рендерим список всех матчей
    function renderMatchesList(data, tournamentId) {
        const currentMonth = moment().locale('ru').format('MM YYYY');
        let $monthYearHolder;
        let monthYear;

        calendarList.html('');

        $.each(data, function(index,value) {
            renderMonthBlock(value, tournamentId);
        });

        // рендерим блок с матчами месяца
        function renderMonthBlock(item, tournamentId) {
            const matchDate =  moment(item.date).locale('ru');
            const dateString = matchDate.format('MMMM YYYY'); // дата- текст заголовок блока
            let heading = dateString.charAt(0).toUpperCase() + dateString.slice(1); // приводим первую букву к верхнему регистру.

            if (['soon', '', null, undefined].includes(item.date)) heading = 'Дата и время будут объявлены позже'; // текст заголовка, если дата еще неизвестна

            if (heading !== monthYear) { // проверка, если месяц текущего матча не совпадает с предыдущим матчем
                const $headingHolder = $(`<h2 class="heading"></h2>`); // элемент заголовка
                const $contentHolder = $('<div class="content"></div>');  // контейнер для отрендеренных матчей

                $monthYearHolder = $(`<div class="month-year"></div>`); //создаем новый(следующий) блок с матчами месяца
                monthYear = heading;
                $headingHolder.html(heading);
                $contentHolder.append(renderMatch(item, tournamentId));
                $monthYearHolder.append($headingHolder);
                $monthYearHolder.append($contentHolder);
                calendarList.append($monthYearHolder);

                if (currentMonth === matchDate.format('MM YYYY')) $monthYearHolder.attr('data-current-month', ''); //текущему месяцу добавляем атрибут, для якорного подскролливания
            } else {
                const $contentHolder = $monthYearHolder.find('.content');
                $contentHolder.append(renderMatch(item, tournamentId));
            }
        }


        // рендерим один матч
        function renderMatch(item,tournamentId) {
            let result =  '';
            let total = '';
            let goal1 = '—';
            let goal2 = '—';
            const hideImageClass = item.tournament.logo ? item.tournament.logo : 'hidden'; // скрываем данные о результате, если матч еще не состоялся.
            let date; // получаем дату матча.

            //если указана только дата без времени
            if(item.date.substr(item.date.length - 8) === '00:00:00'){
                date = moment(item.date).locale('ru').format('DD MMM ddd');

            }else{
                date = moment(item.date).locale('ru').format('DD MMM ddd HH:mm');

            }

            //костыль на женскую лигу и контрольные матчи (откл клик)
            let offClickStyle = ''
            if(tournamentId === 5 || tournamentId === 4){
                offClickStyle = 'pointer-off'
            }

            if (+item.status === 2) {
                result =  getMatchResult(item); // Получаем итог матча  (win, lose, draw)
                total = getLocalizedResult(result); // Переводим на русский / английский язык  (победа, поражение, ничья)
            }

            if (+item.status !== 0) {
                goal1 = item.goal1;
                goal2 = item.goal2;
            }

            if (['soon', '', null, undefined].includes(item.date)) return '—';

            return `
            <div class="match ${offClickStyle}" data-tournament="${item.tournament.id ? item.tournament.id : ''}">
                <a href="${item.link ? item.link : ''}" class="match-link"></a>
                <div class="score-block">
                    <img class="team-logo owner" src="${item.club1.logo ? item.club1.logo : ''}" alt="${item.club1.name ? item.club1.name : ''}">
                    <span class="score">
                        ${goal1} : ${goal2}
                    </span>
                    <img class="team-logo guest" src="${item.club2.logo ? item.club2.logo : ''}" alt="${item.club2.name ? item.club2.name : ''}">
                </div>
                <div class="teams-names">${item.club1.name ? item.club1.name : ''} — ${item.club2.name ? item.club2.name : ''}</div>
                <div class="date">${date}</div>
                <div class="place ${item.stadium ? '' : 'hide-icon'}">
                    ${item.stadium}
                </div>
                <div class="league">
                    <img class="${hideImageClass}" src="${item.tournament.logo ? item.tournament.logo : ''}" alt="${item.tournament.name ? item.tournament.name : ''}">
                    <span>
                        ${item.tournament.name}${item.tournament.roundNumber ? ',' : ''}
                        <span class="tour-number ${item.tournament.roundNumber ? '' : 'hide'}"> ${item.tournament?.roundNumber}</span>
                    </span>                     
                </div>
                <div class="result ${result}">${total}</div>
            </div>
        `;
        }

        // вычисляем результат матча (победа, поражение, ничья)
        // возвращаем строки 'win', 'lose', 'draw' соответственно.
        // Если матч еще не состоялся получаем '—'
        function getMatchResult(item) {
            const goal1 = Number(item.goal1);
            const goal2 = Number(item.goal2);


            if (item.status === 0 || item.status === '0') return '—';
            if (['', null, undefined].includes(item.goal1)) return '—';
            if (['', null, undefined].includes(item.goal2)) return '—';
            if (goal1 === goal2) return 'draw';

            if (item.club1.id === '26') {
                if (goal1 > goal2) return 'win';
                if (goal1 < goal2) return 'lose';

            } else if (item.club2.id === '26') {
                if (goal1 < goal2) return 'win';
                if (goal1 > goal2) return 'lose';
            }

        }

        // преобразуем вычисленные выше данные в читабельный для пользователя формат
        // позднее в эту функцию можно будет добавить английские варианты слов.
        function getLocalizedResult(str) {
            let total;

            switch (str) {
                case 'win':
                    total = 'Победа'
                    break;

                case 'lose':
                    total = 'Поражение'
                    break;

                case 'draw':
                    total = 'Ничья'
                    break;

                case '—':
                    total = ''
                    break;

                default:
                    total =  '';
                    break;
            }

            return total;
        }
    }

    // выводим сообщение, если сервер вернул ошибку или неверные данные
    function renderErrorMessage() {
        const errorBlock =  `                
                <div class="month-year">                
                    <h3 class="heading">Произошла неизвестная ошибка</h3>
                    <p>Попробуйте снова или перезагрузите страницу</p>
                </div>
            `;
        calendarList.html('');
        calendarList.append(errorBlock);
    }

    // отправляем запрос на сервер c фильтрующими данными матчей, которые хочет получить пользователь.
    function getMatches() {
        const selectsData = {
            tournamentId: +$('[data-tournament-select]').val(),
            seasonId: +$('[data-season-select]').val()
        }

        calendarPreloader.removeClass('hide');
        selectsContainer.addClass('load');

        $.ajax({
            url: '/ajax/getcalendarlist/',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(selectsData),
            success: (res) => {
                if (!res && !res.length) {
                    renderErrorMessage();
                    // renderMatchesList(mockData);
                    setTimeout(() => {
                        selectsContainer.removeClass('load');
                        calendarPreloader.addClass('hide');
                        scrollToCurrentMonth();
                    }, 500);
                } else {
                    renderMatchesList(res, selectsData.tournamentId);
                }

                setTimeout(() => {
                    selectsContainer.removeClass('load')
                    calendarPreloader.addClass('hide');
                    scrollToCurrentMonth();
                }, 500);
            },
            error: (res) => {
                renderErrorMessage();
                // renderMatchesList(mockData);
                setTimeout(() => {
                    selectsContainer.removeClass('load');
                    calendarPreloader.addClass('hide');
                    scrollToCurrentMonth();
                }, 500);
            },
        });
    }

    //подскроливаем к текущему месяцу
    function scrollToCurrentMonth() {
        if (!header.length && !pageHead.length) return

        const wHeight = $(window).height();
        const currentMonth = $('[data-current-month]');
        const additionalIndent = 10;
        const  headerHeight = header.outerHeight();
        const  pageHeadHeight = pageHead.outerHeight();

        if (currentMonth.length) {
            let scrollTopCoordinate = currentMonth.offset().top - headerHeight - pageHeadHeight - additionalIndent

            if (scrollTopCoordinate > wHeight) {
                scrollTopCoordinate = currentMonth.offset().top - pageHeadHeight - additionalIndent;
            }

            $('html, body').animate( {
                scrollTop: scrollTopCoordinate,
            }, 1000);
        }
    }

}
